module.exports = __webpack_public_path__ + "media/images/regional-image4-c2c06742578d0db1a4031fd3a925707c.jpg";